import { useCallback } from 'react'

import { useAppDepsContext } from '../../core/hooks/useAppDepsContext'

export default function useLogout() {
  const { authService } = useAppDepsContext()

  const logout = useCallback(() => {
    const wnd = window.open(
      'https://accounts.google.com/logout',
      'logout',
      'toolbar=no, menubar=no, width=600, height=700, top=100, left=100',
    )

    setTimeout(() => {
      if (wnd) {
        wnd.close()
      }

      authService.logout()
    }, 1500)
  }, [])

  return logout
}
